import { handleDefaultModal } from '../../scripts/handleDefaultModal';

const modalSelector = '#video-modal';
const modal = document.querySelector(modalSelector);
const iframe = modal ? modal.querySelector('iframe') : null;

const onPlayerMessage = (e) => {
  try {
    const msg = typeof e.data === 'string' ? JSON.parse(e.data) : e.data;
    if (msg.type === 'player:ready' && iframe) {
      iframe.contentWindow.postMessage(JSON.stringify({ type: 'player:play', data: {} }), '*');
    }
  } catch (_) {}
};

const onClickShowModal = (e) => {
  let videoUrl = e.currentTarget.dataset.videoUrl;
  if (!videoUrl || !iframe) return;

  window.addEventListener('message', onPlayerMessage);
  iframe.src = videoUrl;

  handleDefaultModal(modalSelector, () => {
    window.removeEventListener('message', onPlayerMessage);
    iframe.src = '';
  }, { disableCloseOnWrapper: true });
};

export default function initVideoModal() {
  document.querySelectorAll('[data-video-modal]').forEach((btn) => {
    btn.addEventListener('click', onClickShowModal);
  });
}
